export const CommercialHistoryItemLayoutTypes = {
    DETAIL: "detail",
    INLINE: "inline"
} as const;

export const CommercialHistoryItemStatusTypes = {
    SIMULATION_COMPLETE: "simulation-complete",
    SIMULATION_RUNNING: "simulation-running",
    OPEN_CONVERSATION: "open-conversation",
    WORKFLOW: "workflow"
    /* SCENARIO: "scenario",
    DECISION: "decision" */
} as const;
